// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8r-3";
export var contentContainer = "_8r-0";
export var editorContainer = "_8r-1";
export var quillInputForm = "_8r-2";
export var zoneDivider = "_8r-4";